<mat-radio-group
    class="grid gap-4 md:grid-cols-2"
    aria-label="Billing cadence"
    [value]="selectedCadence()"
>
    @for (card of cards(); track card.cadence) {
        <!-- eslint-disable-next-line agentic/require-qpx-form-control-directive -- Hero pricing cards need custom radio styling, not shared in-app qpx radio styling. -->
        <mat-radio-button
            class="publish-plan-option"
            [class.is-selected]="selectedCadence() === card.cadence"
            [id]="planOptionId(card.cadence)"
            [value]="card.cadence"
            (change)="selectCadence(card.cadence)"
        >
            <span
                class="publish-plan-card relative flex min-h-40 flex-col justify-center rounded-md border border-border p-5 transition-colors"
            >
                <span
                    class="publish-plan-label mt-1 block text-center text-lg font-semibold text-foreground"
                >
                    {{ card.label }}
                </span>
                <span
                    class="mt-2 block text-center text-2xl font-bold text-foreground"
                >
                    {{ card.price }}
                    <span class="text-sm font-semibold text-foreground">
                        {{ card.priceCadence }}
                    </span>
                </span>
                <span class="mt-1 block text-center text-sm text-muted">
                    {{ card.billingLabel }}
                </span>
            </span>
        </mat-radio-button>
    }
</mat-radio-group>
